import { Observer, observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import BaseDashboard from "../../../Layouts/DashboardSignals/BaseDashboard";
import { useResizeObserver } from "../../../utils/useResizeObserver";
import { useStore } from "../../../utils/useStore";
import { LandingDashboardStore } from "./Stores/LandingDashboardStore";

type Props = { isSignals: boolean };

const LandingDashboard: FunctionComponent<Props> = observer((props) => {
    const store = useStore(LandingDashboardStore);
    if (props.isSignals) {
        store.dashboardStore.editDashboardAnchorPosition = "right";
    } else {
        store.dashboardStore.editDashboardAnchorPosition = "left";
    }
    const { elementHeight, elementWidth, theRef } =
        useResizeObserver<HTMLDivElement>();

    return (
        <Observer>
            {() => (
                <div
                    style={{
                        height: props.isSignals ? "calc(100% - 89px)" : "100%",
                        position: "relative",
                        marginLeft:
                            store.dashboardStore.isWidgetsDrawerOpen &&
                            !props.isSignals
                                ? "340px"
                                : "0px",
                        marginRight:
                            store.dashboardStore.isWidgetsDrawerOpen &&
                            props.isSignals
                                ? "340px"
                                : "0px",
                        width: `calc(100% - ${
                            store.dashboardStore.isWidgetsDrawerOpen
                                ? "340px"
                                : "0px"
                        }`,
                    }}
                    ref={theRef}
                >
                    {Boolean(elementWidth && elementHeight) && (
                        <BaseDashboard
                            width={elementWidth ?? 0}
                            height={elementHeight ?? 0}
                            dashboardStore={store.dashboardStore}
                            isSignals={props.isSignals}
                        />
                    )}
                </div>
            )}
        </Observer>
    );
});

export default LandingDashboard;
